export default
{
  isLogged: {
    textTrue: 'Zalogowano agenta: ',
    textFalse: 'Wylogowano agenta: ',
  },
  isPaused: {
    textTrue: 'Włączono przerwę dla agenta: ',
    textFalse: 'Wyłączono przerwę dla agenta: ',
  },
  isDnd: {
    textTrue: 'Włączono DND dla agenta: ',
    textFalse: 'Wyłączono DND dla agenta: ',
  },
  isTalking: {
    textTrue: 'Rozpoczęto proces dzwonienia dla agenta: ',
    textFalse: 'Zakończono proces dzwonienia dla agenta: ',
  },
};
